import { types } from 'mobx-state-tree';

export const AppealTopicModel = types.model('AppealTopicModel', {
  _id: types.optional(types.identifier, ''),
  name: types.optional(types.string, ''),
  deadline_days: types.optional(types.number, 30),
  gis_code: types.optional(types.string, ''),
  gis_uid: types.optional(types.string, ''),
});

export const AppealTopicsListModel = types.model('AppealTopicsListModel', {
  group_name: types.optional(types.string, ''),
  topics: types.optional(types.array(AppealTopicModel), []),
});
